import { apiSlice } from "app/api/apiSlice"


export const devicesSettingsApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['devicesSettings'],
    endpoints: builder => ({
        getDevicesSettings: builder.query({
            query: () => 'devices/settings',
            keepUnusedDataFor: 5,
            providesTags: ['devicesSettings']
        }),
        setDevicesSettings: builder.mutation({
            query: data => ({
                url: 'devices/settings',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['devicesSettings']
        })
    })
})

export const {
    useGetDevicesSettingsQuery,
    useLazyGetDevicesSettingsQuery,
    useSetDevicesSettingsMutation
} = devicesSettingsApiSlice